<template>
  <div v-if="modelValue">
    <div class="text-center">
      <v-progress-circular color="red" indeterminate size="50" />
      <p class="ma-0 mt-4">Exportando... aguarde.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
